import { combineReducers } from 'redux';
import errors from 'reducers/errors/errors';
import session from 'reducers/session/session';
import site_info from 'reducers/site_info/site_info';

export default combineReducers({
    session,
    errors,
    site_info
});